






































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ModalSize } from './modal-size'
import vClickOutside from 'v-click-outside'

@Component<Modal>({
    directives: {
        clickOutside: vClickOutside.directive
    }
})
export default class Modal extends Vue {
    @Prop({ type: Boolean, default: false }) public show!: boolean
    // whether show a raw modal with no header/padding/button
    @Prop({ type: Boolean, default: false }) public vanilla!: boolean
    @Prop({ type: Number, default: 30 }) public padding!: number
    @Prop({ type: Number, default: 0 }) public borderRadius!: number
    @Prop({ type: Boolean, default: true }) public hasHeader!: boolean
    @Prop({ type: Boolean, default: false }) public flex!: boolean
    @Prop({ type: String, required: false }) public flexDirection!: boolean
    @Prop({ type: Boolean, default: true }) public hasClose!: boolean
    // when click out, close modal
    @Prop({ type: Boolean, default: false }) public allowClickOut!: boolean
    // when press escape, close modal
    @Prop({ type: Boolean, default: false }) public allowEscape!: boolean
    @Prop({ type: String, default: '' }) public title!: string
    @Prop({ type: Function, default: () => 0 }) public close!: () => void
    @Prop({ type: String, default: ModalSize.Medium}) public size!: ModalSize
    @Prop({ type: Boolean, default: true }) public bg!: boolean // if to add the bg color
    @Prop({ type: Boolean, default: false }) public smallHeader!: boolean
    @Prop({ type: Boolean, default: false }) public visibleIfOverflow!: boolean // if visible when the content overflow
    @Prop({ type: Number, default: 0 }) public top!: number
    @Prop({ type: Number, default: 0 }) public height!: number
    @Prop({ type: String, default: '' }) public width!: string
    @Prop({ type: Number, default: 0 }) public maxWidth!: number
    @Prop({ type: Boolean, default: false }) public shake!: boolean

    public mounted() {
        if (this.allowEscape) {
            document.addEventListener('keydown', (event: KeyboardEvent) => {
                if (this.show && event.key === 'Escape') {
                    this.close()
                }
            })
        }
        this.$on('close', this.close)
    }

    public get isLarge() {
        return this.size === ModalSize.Large
    }

    public get isFull() {
        return this.size === ModalSize.Full
    }

    public get styles() {
        let style = ''

        if (this.borderRadius) {
            style += `border-radius: ${this.borderRadius}px;`
        }

        if (this.height) {
            style += `height: ${this.height}px;`
        }

        if (this.width) {
            style += `width: ${ this.width };`
        }

        if (this.maxWidth) {
            style += `max-width: ${ this.maxWidth }px;`
        }

        if (this.flex) {
            style += `display: flex;`
        }

        if (this.flexDirection) {
            style += `flex-direction: ${ this.flexDirection };`
        }

        return style
    }

    public get getContentStyle() {
        let style = ''
        if (this.padding) {
            style += `padding: ${this.padding}px;`
        }
        return style
    }

    public clickOut() {
        if (!this.allowClickOut) {
            return
        }

        this.close()
    }
}
